
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Creare tablou de bord',
	'dashboard': 'Tablou de bord',
	'dashboardTemplate': 'Şablon de tablou de bord',
	'createAV': 'Creare',
	'createAvEditNameLabel': '1. Denumiţi-vă vizualizarea',
	'createAvSelectTemplateLabel': '2. Selectaţi un şablon',
	'tabLayoutLabel': 'Şablon cu file',
	'infographicsLayoutLabel': 'Şablon de infografic',
	'singlePageLayoutLabel': 'Şablon de pagină singulară',
	'customLayoutLabel': 'Şablon personalizat',
	'freeformTemplate': 'Formă liberă',
	'freeformTemplateDesc': 'Vizualizările dintr-o dispunere cu formă liberă apar exact cum le-aţi dimensionat şi plasat în vizualizare, indiferent de dimensiunea ecranului. În alte dispuneri, dimensiunea şi poziţia vizualizărilor se ajustează  pentru a se potrivi în ecran.',
	'NoTemplate': 'Formă liberă',
	'Template1': 'Necompletat',
	'Template2': 'Titlu 1 din 2',
	'Template3': '2 peste 1',
	'Template4': '4 peste 1',
	'Template5': 'Subsol 1 din 2',
	'Template6': '3 lângă 1 peste 1',
	'Template7': '4 lângă 3 peste 1',
	'Template8': '2 peste 3 din 2',
	'Template9': '2 din 2',
	'Template10': '1 din 2 lângă 2 din 2 peste 1',
	'Template11': '3 din 1 peste 1 din 2',
	'Template12': '2 peste 1 lângă 1 din 2',
	'Template13': 'Unu lângă 1 din 2 lângă 1 din 4',
	'Template22': '1 peste 2 din 2',
	'Template14': '1 lângă 1',
	'Template15': '1 peste 1 lângă 1',
	'Template16': '1 lângă 1 peste 1',
	'Template17': '1 peste 1 lângă 1 peste 1',
	'Template18': '1 peste 1 lângă 1',
	'Template19': '1 peste 2 lângă 1',
	'Template20': '1 peste 2 din 1',
	'Template21': '1 peste 1 peste 2 din 1',
	'Template23': 'Necompletat cu zonă de fixare',
	'Infographics1': 'Necompletat',
	'Infographics2': '4 rânduri',
	'Infographics3': '4 rânduri cu anteturi',
	'Infographics4': '2 din 4',
	'Infographics5': 'Afişare mare sus cu 2 din 2',
	'Infographics6': '2 din 4 cu spaţiu vertical',
	'Infographics7': '2 din 4 decalat',
	'Infographics8': 'Teren de tenis',
	'Infographics9': '3 din 4',
	'Infographics10': '4 din 8',
	'createAvDashboardLabel': 'Dispunere',
	'dashboard_template_save_success': 'Tabloul dumneavoastră de bord a fost salvat.',
	'dashboard_template_prefix': 'Şablon: "%{name}"',
	'dashboard_template_filters_removed': 'Filtrele de pe canava au fost înlăturate.',
	'createAvTabLabel': 'Cu file',
	'createAvInfographicsLabel': 'Infografic',
	'createAvSinglepageLabel': 'Pagină singulară',
	'createAvCustomLabel': 'Personalizat',
	'loadMoreLabel': 'Încărcare mai multe...',
	'backLabel': 'Deplasare înapoi',
	'addSourceLabel': 'Adăugarea unei surse',
	'pinLabel': 'Ţintuire',
	'errorLoadingDataSetMetaData': 'A apărut o eroare la citirea metadatelor',
	'errorLoadingDataSets': 'A apărut o eroare la încărcarea listei de seturi de date',
	'errorLoadingDataSet': 'Metadatele pentru setul de date "%{datasetName}" nu au fost încărcate. Contactaţi administratorul pentru detalii.',
	'okButton': 'OK',
	'createButton': 'Creare',
	'cancelButton': 'Anulare',
	'copyButton': 'Copiere',
	'selectTemplateLabel': 'Selectarea unui şablon',
	'createBoardTitle': 'Creare tablou de bord',
	'createBoardSubtitle': 'Selectare şablon pentru tabloul de bord',
	'noSourcesSelectedLabel': 'Nicio sursă selectată',
	'find_label': 'Găsire',
	'noDashboardFound': 'Nu a putut fi extras tabloul de bord. Fie nu mai există, fie nu aveţi suficiente privilegii pentru a o vizualiza.',
	'errorLabel': 'Eroare',
	'defaultName': 'Tablou de bord nou',
	'noDashboardCapability': 'Nu aveţi aptitudinea de a rula aplicaţia tablou de bord',
	'noDashboardPermission': 'Nu aveţi suficiente privilegii pentru a vizualiza acest tablou de bord',
	'sourceNotFound': 'Vizualizarea nu poate fi încărcată, deoarece nu este disponibilă sursa sa asociată "%{sourceName}"',
	'cmDuplicateName': 'Deja există un articol cu acest nume. Încercaţi alt nume.',
	'cmEmptySelection': 'Tabloul de bord a fost şters. Încercaţi salvarea ca tablou de bord nou.',
	'propTheme': 'Temă vizual',
	'legacyThemeLabel': 'Moştenită',
	'carbonGrey10Label': 'Carbon X luminos',
	'carbonGrey100Label': 'Carbon X întunecat',
	'titleTextLabel': 'Titlu',
	'titleSmallTextLabel': 'Titlu mic',
	'subtitleTextLabel': 'Subtitlu',
	'bodyTextLabel': 'Corp',
	'bodySmallTextLabel': 'Corp mic',
	'captionTextLabel': 'Subtitlu',
	'quoteTextLabel': 'Ghilimele',
	'quoteSmallTextLabel': 'Ghilimele mici',
	'responsiveTextLabel': 'Dimensionare automată',
	'mediaWidgetLabel': 'Media',
	'webpageWidgetLabel': 'Pagină web',
	'imageWidgetLabel': 'Imagine',
	'textWidgetLabel': 'Text',
	'notebookWidgetLabel': 'Carnet',
	'multipurposeWidgetLabel': 'Scop general',
	'textPlaceHolder': 'Faceţi clic pentru a edita textul',
	'titlePlaceHolder': 'Faceţi clic pentru a edita titlul',
	'toggleEditModeLabel': 'Comutare la editare',
	'togglePreviewModeLabel': 'Comutare la previzualizare',
	'editDashboardCoachMarkTitle': 'Editare tablou de bord',
	'editDashboardCoachMarkContents': 'Faceţi clic pe pictograma creion pentru a edita acest tablou de bord.',
	'addDataCoachMarkTitle': 'Adăugare date',
	'addDataDashboardCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date pe tabloul dumneavoastră de bord.',
	'pageSelectWarning': 'Vă rugăm să selectaţi o filă.',
	'screenshot_label': 'Tablou de bord %{title}',
	'screenshot_label_tab': 'Fila %{tabName} din tabloul de bord %{title}',
	'dataAssetPropertiesLabel': 'Proprietăţi de vizualizare',
	'modelFilter': 'Filtru',
	'invertSelectionToolTip': 'Inversare selecţii de filtrare',
	'clearFilterValueToolTip': 'Curăţare valori de filtrare',
	'invertFilterSelection': 'Inversare',
	'clearTextFilterValue': 'Curăţare',
	'filterConditionLabel': 'Condiţie de filtrare',
	'applyFilter': 'Aplicare filtru',
	'itemCountText': '%{itemCount} articole selectate',
	'itemExcludeCountText': '%{itemCount} articole excluse',
	'moreMembers': 'Afişare mai multe...',
	'searchHierarchyMembers': 'Utilizarea căutării pentru a găsi membri...',
	'propHideEmpty': 'Ascundere gol',
	'propColorOrder': 'Ordinea culorilor',
	'propElementColor': 'Vizualizare culoare element',
	'propLineColor': 'Culoare linie',
	'propLineAndSymbolColor': 'Culoare linie şi simbol',
	'propColumnColor': 'Culoare coloană',
	'propBarColor': 'Culoare bară',
	'propWordColor': 'Culoare cuvânt',
	'propAreaColor': 'Culoare zonă',
	'propRadialbarColor': 'Culoare bară radială',
	'propColorPalettes': 'Palete de culori',
	'propDashboardColorPalette': 'Paletă tablou de bord curentă',
	'propNewDashboardPaletteLabel': 'Creare paletă tablou de bord personalizată',
	'propDashboardChangePaletteLink': 'Modificare paletă tablou de bord',
	'propHideLeafNode': 'Ascundere etichete frunză',
	'propOpacity': 'Opacitate',
	'propOpacityDescription': 'Faceţi obiectul mai mult sau mai puţin opac. Introduceţi o valoare între 0 şi 100',
	'addATab': 'Adăugaţi o nouă filă',
	'propFredIsRed': 'Consistenţă culoare',
	'areaChartCaption': 'Suprafaţă',
	'areaChartDataSlot_categoriesLabel': 'Etichetă axă',
	'areaChartDataSlot_valuesLabel': 'Valoare',
	'areaChartProp_colorPaletteLabel': 'Palete de culori',
	'areaChartProp_lineColorLabel': 'Culoare zonă',
	'areaChartProp_interpolationLabel': 'Linii line',
	'areaChartProp_interpolationDescription': 'Liniile care conectează punctele de date sunt curbate.',
	'areaChartProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'areaChartProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'areaChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'areaChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'areaChartProp_suppressZerosLabel': 'Ascundere gol',
	'areaChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'barChartCaption': 'Bară',
	'barChartDataSlot_categoriesLabel': 'Etichetă axă',
	'barChartDataSlot_valuesLabel': 'Valoare',
	'barChartProp_colorPaletteLabel': 'Palete de culori',
	'barChartProp_elementColorLabel': 'Culoare bară',
	'barChartProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'barChartProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'barChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'barChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'barChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'barChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'barChartProp_suppressZerosLabel': 'Ascundere gol',
	'barChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'columnChartCaption': 'Coloană',
	'columnChartDataSlot_categoriesLabel': 'Etichetă axă',
	'columnChartDataSlot_valuesLabel': 'Valoare',
	'columnChartProp_colorPaletteLabel': 'Palete de culori',
	'columnChartProp_elementColorLabel': 'Culoare coloană',
	'columnChartProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'columnChartProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'columnChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'columnChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'columnChartProp_suppressZerosLabel': 'Ascundere gol',
	'columnChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'bubbleChartCaption': 'Bulă',
	'bubbleChartDataSlot_xAxisLabel': 'Axă orizontală',
	'bubbleChartDataSlot_yAxisLabel': 'Axă verticală',
	'bubbleChartDataSlot_sizeLabel': 'Mărime după',
	'bubbleChartDataSlot_colorLabel': 'Culoare după',
	'bubbleChartProp_colorPaletteLabel': 'Palete de culori',
	'bubbleChartProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'bubbleChartProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'bubbleChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'bubbleChartProp_hideLegendLabel': 'Ascundere legendă',
	'bubbleChartProp_hideLegendDescription': 'Ascundeţi legenda.',
	'bubbleChartProp_legendPositionLabel': 'Poziţie legendă',
	'lineChartCaption': 'Linie',
	'lineChartDataSlot_categoriesLabel': 'Etichetă axă',
	'lineChartDataSlot_valuesLabel': 'Valoare',
	'lineChartProp_colorPaletteLabel': 'Palete de culori',
	'lineChartProp_lineColorLabel': 'Culoare linie şi simbol',
	'lineChartProp_symbolShapeLabel': 'Formă de simbol',
	'lineChartProp_hideSymbolsLabel': 'Ascundere simboluri',
	'lineChartProp_hideSymbolsDescription': 'Ascundere simboluri',
	'lineChartProp_hideDataLinesLabel': 'Ascundere linii',
	'lineChartProp_hideDataLinesDescription': 'Ascundere linii',
	'lineChartProp_interpolationLabel': 'Linii line',
	'lineChartProp_interpolationDescription': 'Liniile care conectează punctele de date sunt curbate.',
	'lineChartProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'lineChartProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'lineChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'lineChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'lineChartProp_suppressZerosLabel': 'Ascundere gol',
	'lineChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'packedBubbleChart1CatCaption': 'Bulă împachetată',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Categorii',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Mărime după',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Palete de culori',
	'packedBubbleChart1CatProp_elementColorLabel': 'Culoare bulă',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Ascundere etichetă',
	'packedBubbleChart1CatProp_hideValueLabel': 'Ascundere valoare',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Ascundere gol',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'heatChartCaption': 'Căldură',
	'heatChartDataSlot_valuesLabel': 'Căldură după',
	'heatChartDataSlot_xAxisLabel': 'Axă orizontală',
	'heatChartDataSlot_yAxisLabel': 'Axă verticală',
	'heatChartProp_colorPaletteLabel': 'Palete de culori',
	'heatChartProp_heatScalePaletteLabel': 'Ordinea culorilor',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'heatChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'heatChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'heatChartProp_suppressZerosLabel': 'Ascundere gol',
	'heatChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'heatChartProp_hideLegendLabel': 'Ascundere legendă',
	'heatChartProp_hideLegendDescription': 'Ascundeţi legenda.',
	'heatChartProp_legendPositionLabel': 'Poziţie legendă',
	'pieChartCaption': 'Radială',
	'pieChartDataSlot_categoriesLabel': 'Categorii',
	'pieChartDataSlot_valuesLabel': 'Valoare',
	'pieChartProp_colorPaletteLabel': 'Palete de culori',
	'pieChartProp_hideRadialValueLabel': 'Ascundere valoare',
	'pieChartProp_pieAsDonutLabel': 'Afişare ca diagramă tor',
	'pieChartProp_pieAsDonutDescription': 'Afişare ca diagramă tor',
	'pieChartProp_suppressZerosLabel': 'Ascundere gol',
	'pieChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'pieChartProp_hideLegendLabel': 'Ascundere legendă',
	'pieChartProp_hideLegendDescription': 'Ascundeţi legenda.',
	'pieChartProp_legendPositionLabel': 'Poziţie legendă',
	'map1measureCaption': 'Hartă',
	'map1measureDataSlot_categoriesLabel': 'Regiuni',
	'map1measureDataSlot_valuesLabel': 'Căldură regiune',
	'map1measureProp_colorPaletteLabel': 'Palete de culori',
	'map1measureProp_heatScalePaletteLabel': 'Ordinea culorilor',
	'map1measureProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'map1measureProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'map1measureProp_suppressZerosLabel': 'Ascundere gol',
	'map1measureProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'map1measureProp_hideLegendLabel': 'Ascundere legendă',
	'map1measureProp_hideLegendDescription': 'Ascundeţi legenda.',
	'map1measureProp_legendPositionLabel': 'Poziţie legendă',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Categorii',
	'radialChartDataSlot_valuesLabel': 'Valoare',
	'radialChartProp_colorPaletteLabel': 'Palete de culori',
	'radialChartProp_elementColorLabel': 'Culoare bară radială',
	'radialChartProp_hideRadialTitleLabel': 'Ascundere titlu',
	'radialChartProp_hideRadialValueLabel': 'Ascundere valoare',
	'radialChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'radialChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'radialChartProp_suppressZerosLabel': 'Ascundere gol',
	'radialChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'pointChart1catCaption': 'Punct',
	'pointChart1catDataSlot_valuesLabel': 'Valoare',
	'pointChart1catDataSlot_categoriesLabel': 'Etichetă axă',
	'pointChart1catProp_colorPaletteLabel': 'Palete de culori',
	'pointChart1catProp_elementColorLabel': 'Culoare formă',
	'pointChart1catProp_symbolShapeLabel': 'Formă de simbol',
	'pointChart1catProp_symbolFillLabel': 'Umplere formă',
	'pointChart1catProp_symbolFillDescription': 'Afişaţi culoarea de umplere pentru simboluri.',
	'pointChart1catProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'pointChart1catProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'pointChart1catProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'pointChart1catProp_suppressZerosLabel': 'Ascundere gol',
	'pointChart1catProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'scatterPlotChartNoCatCaption': 'Trasare prin puncte',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Axă orizontală',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Axă verticală',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Palete de culori',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Culoare element',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Formă de simbol',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Umplere formă',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Afişaţi culoarea de umplere pentru simboluri.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'radialBarChartCaption': 'Bară radială',
	'radialBarChartDataSlot_categoriesLabel': 'Categorii',
	'radialBarChartDataSlot_valuesLabel': 'Valoare',
	'radialBarChartProp_colorPaletteLabel': 'Palete de culori',
	'radialBarChartProp_elementColorLabel': 'Culoare bară radială',
	'radialBarChartProp_hideRadialTitleLabel': 'Ascundere titlu',
	'radialBarChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'radialBarChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'radialBarChartProp_suppressZerosLabel': 'Ascundere gol',
	'radialBarChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'lineColumnComboChartCaption': 'Linie şi coloană',
	'lineColumnComboChartDataSlot_categoryLabel': 'Etichetă axă',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Valoare linie',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Valoare coloană',
	'lineColumnComboChartProp_colorPaletteLabel': 'Palete de culori',
	'lineColumnComboChartProp_elementColorLabel': 'Culoare coloană',
	'lineColumnComboChartProp_lineColorLabel': 'Culoare linie şi simbol',
	'lineColumnComboChartProp_symbolShapeLabel': 'Formă de simbol',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Ascundere simboluri',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Ascundere simboluri',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Ascundere linii',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Ascundere linii',
	'lineColumnComboChartProp_interpolationLabel': 'Linii line',
	'lineColumnComboChartProp_interpolationDescription': 'Liniile care conectează punctele de date sunt curbate.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Ascundere linii grilă',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Ascundere linii grilă',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Ascundere etichete titlu axă',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Ascundeţi titlurile axei.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Ascundere gol',
	'lineColumnComboChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'lineColumnComboChartProp_hideLegendLabel': 'Ascundere legendă',
	'lineColumnComboChartProp_hideLegendDescription': 'Ascundeţi legenda.',
	'lineColumnComboChartProp_legendPositionLabel': 'Poziţie legendă',
	'summaryCaption': 'Sumar',
	'areaName': 'Suprafaţă',
	'areaDescription': 'Suprafaţă',
	'areaDataSlot_colorLabel': 'Culoare după',
	'areaDataSlot_valuesLabel': 'Valoare',
	'areaDataSlot_categoriesLabel': 'Etichetă axă',
	'bubbleName': 'Bulă',
	'bubbleDescription': 'Bulă',
	'bubbleDataSlot_yAxisLabel': 'Axă verticală',
	'bubbleDataSlot_xAxisLabel': 'Axă orizontală',
	'bubbleDataSlot_sizeLabel': 'Mărime după',
	'bubbleDataSlot_colorLabel': 'Culoare după',
	'clusterBarName': 'Bară',
	'clusterBarDescription': 'Bară',
	'clusterBarDataSlot_colorLabel': 'Culoare după',
	'clusterBarDataSlot_valuesLabel': 'Valoare',
	'clusterBarDataSlot_categoriesLabel': 'Etichetă axă',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Valoare',
	'clusterColumnName': 'Coloană',
	'clusterColumnDescription': 'Coloană',
	'clusterColumnDataSlot_colorLabel': 'Culoare după',
	'clusterColumnDataSlot_valuesLabel': 'Valoare',
	'clusterColumnDataSlot_categoriesLabel': 'Etichetă axă',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Valoare',
	'clusterLineName': 'Linie',
	'clusterLineDescription': 'Linie',
	'clusterLineDataSlot_colorLabel': 'Culoare după',
	'clusterLineDataSlot_valuesLabel': 'Axă verticală',
	'clusterLineDataSlot_categoriesLabel': 'Axă orizontală',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Valoare',
	'gridName': 'Grilă',
	'gridDescription': 'Grilă',
	'gridDataSlot_grid_colsLabel': 'Coloană',
	'heatName': 'Căldură',
	'heatDescription': 'Căldură',
	'heatDataSlot_yAxisLabel': 'Axă verticală',
	'heatDataSlot_xAxisLabel': 'Axă orizontală',
	'heatDataSlot_valuesLabel': 'Căldură după',
	'lineColumnComboName': 'Linie şi coloană',
	'lineColumnComboDescription': 'Linie şi coloană',
	'lineColumnComboDataSlot_lineValueLabel': 'Valoare linie',
	'lineColumnComboDataSlot_categoryLabel': 'Etichetă axă',
	'lineColumnComboDataSlot_columnValueLabel': 'Valoare coloană',
	'mapName': 'Mapare moştenire',
	'mapDescription': 'Mapare moştenire',
	'mapDataSlot_sizeLabel': 'Mărime în puncte',
	'mapDataSlot_valuesLabel': 'Căldură regiune',
	'mapDataSlot_sizeHeatLabel': 'Căldură punct',
	'mapDataSlot_categoriesLabel': 'Regiuni',
	'packedBubbleName': 'Bulă împachetată',
	'packedBubbleDescription': 'Bulă împachetată',
	'packedBubbleDataSlot_sizeLabel': 'Mărime după',
	'packedBubbleDataSlot_colorLabel': 'Culoare după',
	'packedBubbleDataSlot_categoriesLabel': 'Categorii',
	'pieName': 'Radială',
	'pieDescription': 'Radială',
	'pieDataSlot_valuesLabel': 'Valoare',
	'pieDataSlot_categoriesLabel': 'Categorii',
	'playerName': 'Player de date',
	'playerDescription': 'Player de date',
	'playerDataSlot_categoriesLabel': 'Etichetă axă',
	'pointName': 'Punct',
	'pointDescription': 'Punct',
	'pointDataSlot_colorLabel': 'Culoare după',
	'pointDataSlot_valuesLabel': 'Valoare',
	'pointDataSlot_categoriesLabel': 'Etichetă axă',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Valoare',
	'radialDataSlot_maxSizeLabel': 'Valoare maximă',
	'radialDataSlot_categoriesLabel': 'Categorii',
	'radialBarName': 'Bară radială',
	'radialBarDescription': 'Bară radială',
	'radialBarDataSlot_valuesLabel': 'Valoare',
	'radialBarDataSlot_categoriesLabel': 'Categorii',
	'scatterPlotName': 'Trasare prin puncte',
	'scatterPlotDescription': 'Trasare prin puncte',
	'scatterPlotDataSlot_yAxisLabel': 'Axă verticală',
	'scatterPlotDataSlot_xAxisLabel': 'Axă orizontală',
	'scatterPlotDataSlot_colorLabel': 'Culoare după',
	'scatterPlotDataSlot_categoriesLabel': 'Puncte',
	'stackedBarName': 'Bară stivă',
	'stackedBarDescription': 'Bară stivă',
	'stackedBarDataSlot_colorLabel': 'Culoare după',
	'stackedBarDataSlot_valuesLabel': 'Valoare',
	'stackedBarDataSlot_categoriesLabel': 'Etichetă axă',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Valoare',
	'stackedColumnName': 'Coloană stivă',
	'stackedColumnDescription': 'Coloană stivă',
	'stackedColumnDataSlot_colorLabel': 'Culoare după',
	'stackedColumnDataSlot_valuesLabel': 'Valoare',
	'stackedColumnDataSlot_categoriesLabel': 'Etichetă axă',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Valoare',
	'summaryChartName': 'Sumar',
	'summaryChartDescription': 'Sumar',
	'summaryChartDataSlot_valuesLabel': 'Valoare',
	'treeMapName': 'Hartă arbore',
	'treeMapDescription': 'Hartă arbore',
	'treeMapDataSlot_colorLabel': 'Căldură după',
	'treeMapDataSlot_valuesLabel': 'Mărime după',
	'treeMapDataSlot_categoriesLabel': 'Nivelul unu',
	'treeMapDataSlot_level3Label': 'Nivelul trei',
	'treeMapDataSlot_level2Label': 'Nivelul doi',
	'wordCloudName': 'Nor de cuvinte',
	'wordCloudDescription': 'Nor de cuvinte',
	'wordCloudDataSlot_colorLabel': 'Culoare după',
	'wordCloudDataSlot_scaleLabel': 'Mărime după',
	'wordCloudDataSlot_wordLabel': 'Cuvinte',
	'treeMap1Cat1MeasureChartCaption': 'Hartă arbore',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Nivelul unu',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Mărime după',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Palete de culori',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Palete de culori',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Palete de culori',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Palete de culori',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Palete de culori',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Palete de culori',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Ascundere gol',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Ascundere legendă',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Ascundeţi legenda.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Poziţie legendă',
	'wordChart1Cat1MeasureCaption': 'Nor de cuvinte',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Cuvinte',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Mărime după',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Palete de culori',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Culoare cuvânt',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Menţinere scală pe axă',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Întotdeauna sunt afişate valorile minime şi maxime pe axe.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Ascundere gol',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Ascundere categorii fără valori asociate.',
	'missingDataSetData': 'Datele pentru acest set de date nu sunt disponibile. Reîmprospătaţi setul de date sau contactaţi-vă administratorul pentru accesul la sursă.',
	'hideShowSummaries': 'Ascundere/Afişare rezumate',
	'crosstabName': 'Tabel încrucişat',
	'value_is_not_available': 'N/A',
	'swapRowsAndColumns': 'schimbarea rândurilor şi coloanelor între ele',
	'NoPinsCollected': 'Nicio vizualizare ţintuită',
	'pinSearchOld': 'Căutare ţintuirile mele',
	'pinDeletedToast': 'Ţintuirea a fost înlăturată',
	'pinAddedToast': 'Ţintuirea a fost adăugată cu succes la Ţintuirile mele',
	'pinRetrieveError': 'Nu putem extrage una sau mai multe ţintuiri. Încercaţi din nou mai târziu.',
	'pinErrorTitle': 'Eroare de ţintuire',
	'pinRemove': 'Înlăturare ţintuire',
	'deletePin': 'Ştergere ţintuire',
	'dataset_time': 'oră',
	'dataset_date': 'dată',
	'dataset_location': 'locaţie',
	'dataset_number': 'număr',
	'dataset_text': 'text',
	'widgetConditionalFormatLabel': 'Comutaţi controalele de format condiţional',
	'deletePinConfirmationMessage': 'Sunteţi sigur că doriţi să ştergeţi această ţintuire? Această acţiune nu mai poate fi anulată.',
	'deletePinConfirm': 'Confirmare ştergere',
	'pinDeleteError': 'Nu putem şterge una sau mai multe ţintuiri. Încercaţi din nou mai târziu.',
	'metadataPickerTitle': 'Creare set de date',
	'moreTitle': 'Mai multe',
	'remove_slider_handle': 'Înlăturare handle',
	'missingFiltering': 'Lipsă coloană:',
	'unSupportedPromptType': 'Scenariul de prompturi nu este suportat curent.',
	'preAggregateLabel': 'Aplicaţi valorile prompt din sursa de date',
	'postAggregateLabel': 'Aplicaţi valorile prompt în raport',
	'preAggregateText': 'Intervalul utilizează valorile din sursa de date, nu valorile afişate în tabloul de bord.',
	'tabName_general': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Detalii',
	'tabName_textDetails': 'Detalii de text', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Detalii de mediu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Detalii pagină de Web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Detalii imagine', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Vizualizare',
	'sectionName_canvas': 'Canava',
	'sectionName_colorsAndThemes': 'Culoare şi temă',
	'colorsAndThemes_legacyWarning': 'Tabloul de bord foloseşte o temă de la o ediţie anterioară. Modificarea temei şi salvarea permanentă a tabloului de bord înlătură accesul la platele de teme anterioare. ',
	'sectionName_details': 'Detalii',
	'sectionName_positionAndStyle': 'Poziţie şi stil',
	'sectionName_appearance': 'Aspect', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Avansat',
	'sectionName_layout': 'Dispunere', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'File',
	'sectionName_tabTitle': 'Etichetă',
	'sectionName_tabBackground': 'Fundal',
	'addDataSourceDialogTitle': 'Adăugare sursă de date',
	'addDataSourceDialogButtonLabel': 'Adăugare',
	'shapesDoubleChevron': 'Chevron dublu',
	'widgetsPanelTitle': 'Widget-uri',
	'widgetsPanelBasicsTab': 'Elemente de bază',
	'widgetsPanelImageLibraryTab': 'Imagini',
	'widgetsPanelSectionStandard': 'Standard',
	'widgetsPanelSectionAdvanced': 'Avansat',
	'widgetsPanelSectionShapes': 'Forme',
	'customWidgetsTitle': 'Widget-uri personalizate',
	'filterItemCanvasMove': 'Adăugare la canava',
	'filterOverflowMenu_Global': 'Meniu depăşire toate filele',
	'filterOverflowMenu_Tab': 'Meniu depăşire această filă',
	'filterOverflowMenu_Item': 'Meniu depăşire filtru',
	'filterOverflowMenu_Single': 'Meniu depăşire',
	'filterItemEdit': 'Editare valori de filtru',
	'filterDeleteAllItems': 'Ştergere toate filtrele',
	'filterClearAllItems': 'Curăţare toate filtrele',
	'filterClearSelection': 'Curăţare filtru',
	'filterPlayerMode': 'Afişare player',
	'filterStaticMode': 'Afişare listă',
	'filterInvertSelection': 'Inversare filtru',
	'filterIconLabel_Global': 'Toate filele',
	'filterIconLabel_Single': 'Filtre',
	'filterIconLabel_Tab': 'Această filă',
	'filterIconTooltip_Global': 'Toate filele',
	'filterIconTooltip_Tab': 'Această filă',
	'filterIconTooltip_Single': 'Filtre',
	'filterItemDelete': 'Ştergere filtru',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'totul exceptând: %{from}-%{to}',
	'filterExcept': 'exceptând %{values}',
	'filterAll': 'Toate',
	'filterBlank': '(necompletat)',
	'filterDisableRangeInvert': 'Nu este disponibilă când această coloană este în filtrul "Toate filele".',
	'filterDisableHierarchyInvert': 'Nu este disponibilă când această coloană este într-un filtru de ierarhie.',
	'filterSelectedOfTotal': '%{selected} din %{totalMembers}',
	'filter_date_before': 'Înainte de %{to}',
	'filter_date_before_except': 'Nu înainte de %{to}',
	'filter_date_after': 'După %{from}',
	'filter_date_after_except': 'Nu după %{from}',
	'filter_date_between': 'Între %{from}-%{to}',
	'filter_date_between_except': 'Nu între %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Trageţi şi plasaţi datele aici pentru a filtra toate filele.',
	'filter_drag_and_drop_current_tab': 'Trageţi şi plasaţi datele aici pentru a filtra această filă.',
	'filter_drag_and_drop_single_dock': 'Trageţi şi plasaţi date aici pentru a filtra.',
	'errMsgFilterItemGenericTitle': 'Valorile de filtrare nu au putut fi încărcate',
	'widgetChromeRotate': 'Rotaţie',
	'toolbarRegionLabel': 'Bară de unelte',
	'toolbarActionDelete': 'Ştergere',
	'toolbarActionGroup': 'Grup',
	'toolbarActionUngroup': 'Degrupare',
	'toolbarActionOrderToFront': 'Trimitere în faţă',
	'toolbarActionOrderToBack': 'Trimitere în spate',
	'toolbarActionEditTitle': 'Editarea titlului',
	'toolbarActionWrapTitle': 'Înfăşurare acest titlu',
	'toolbarActionPin': 'Colectare',
	'toolbarActionPinOld': 'Ţintuire',
	'toolbarActionAlign': 'Aliniere',
	'alignWidgetLeft': 'Stânga',
	'alignWidgetCenter': 'Centrare',
	'alignWidgetRight': 'Dreapta',
	'alignWidgetTop': 'Sus',
	'alignWidgetMiddle': 'Mijloc',
	'alignWidgetBottom': 'Jos',
	'toolbarChangeVisualization': 'Modificare vizualizare',
	'multipurposeHeader': 'Selectaţi un tip de widget',
	'multipurposePlaceholderText': 'Selectaţi unul dintre widget-uri pentru a începe.',
	'live_label': 'Diagramă',
	'filter_label': 'Filtru',
	'one_named_live': 'Diagramă %{name}',
	'one_named_live_numbered': 'Diagramă %{name} (%{number})',
	'one_unknown_live': 'Diagramă',
	'one_unknown_live_numbered': 'Diagramă (%{number})',
	'few_live': 'Grup de %{count} diagrame',
	'many_live': 'Grup de %{count} diagrame',
	'one_custom': 'Widget personalizat',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filtru %{name}',
	'one_named_filter_numbered': 'Filtru %{name} (%{number})',
	'one_unknown_filter': 'Filtru',
	'one_unknown_filter_numbered': 'Filtru (%{number})',
	'few_filter': 'Grup de %{count} filtre',
	'many_filter': 'Grup de %{count} filtre',
	'LIVE_bar_has_mapping': 'Diagramă bară %{values}',
	'LIVE_bar_has_mapping_numbered': 'Diagramă bară %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Diagramă bară %{categories} după %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Diagramă bară %{categories} după %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Diagramă bară goală',
	'LIVE_bar_no_mapping_numbered': 'Diagramă bară goală (%{number})',
	'LIVE_bar_named': 'Diagramă bară %{name}',
	'LIVE_bar_named_numbered': 'Diagramă bară %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Diagramă bară stivuită %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Diagramă bară stivuită %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Diagramă bară stivuită %{categories} după %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Diagramă bară stivuită %{categories} după %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Diagramă bară stivuită goală',
	'LIVE_stacked_bar_no_mapping_numbered': 'Diagramă bară stivuită goală (%{number})',
	'LIVE_stacked_bar_named': 'Diagramă bară stivuită %{name}',
	'LIVE_stacked_bar_named_numbered': 'Diagramă bară stivuită %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Diagramă cu bule %{categories} după %{x} şi %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Diagramă cu bule %{categories} după %{x} şi %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Diagramă cu bule goală',
	'LIVE_bubble_no_mapping_numbered': 'Diagramă cu bule goală (%{number})',
	'LIVE_bubble_named': 'Diagramă cu bule %{name}',
	'LIVE_bubble_named_numbered': 'Diagramă cu bule %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Diagramă compusă %{categories} după %{columnValue} şi %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Diagramă compusă %{categories} după %{columnValue} şi %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Diagramă compusă goală',
	'LIVE_composite_no_mapping_numbered': 'Diagramă compusă goală (%{number})',
	'LIVE_composite_named': 'Diagramă compusă %{name}',
	'LIVE_composite_named_numbered': 'Diagramă compusă %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Arbore de decizie %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Arbore de decizie %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Arbore de decizie gol',
	'LIVE_decision_tree_no_mapping_numbered': 'Arbore de decizie gol (%{number})',
	'LIVE_decision_tree_named': 'Arbore de decizie %{name}',
	'LIVE_decision_tree_named_numbered': 'Arbore de decizie %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Diagramă cu bule împachetate %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Diagramă cu bule împachetate %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Diagramă cu bule împachetate goală',
	'LIVE_packed_bubble_no_mapping_numbered': 'Diagramă cu bule împachetate goală (%{number})',
	'LIVE_packed_bubble_named': 'Diagramă cu bule împachetate %{name}',
	'LIVE_packed_bubble_named_numbered': 'Diagramă cu bule împachetate %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Diagramă radială %{categories} după %{values}',
	'LIVE_pie_has_mapping_numbered': 'Diagramă radială %{categories} după %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Diagramă radială goală',
	'LIVE_pie_no_mapping_numbered': 'Diagramă radială goală (%{number})',
	'LIVE_pie_named': 'Diagramă radială %{name}',
	'LIVE_pie_named_numbered': 'Diagramă radială %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Diagramă tor %{categories} după %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Diagramă tor %{categories} după %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Diagramă tor goală',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Diagramă tor goală (%{number})',
	'LIVE_pie_as_donut_named': 'Diagramă tor %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Diagramă tor %{name} (%{number})',
	'LIVE_line_has_mapping': 'Diagramă linie %{categories} după %{values}',
	'LIVE_line_has_mapping_numbered': 'Diagramă linie %{categories} după %{values} (%{number})',
	'LIVE_line_no_mapping': 'Diagramă linie goală',
	'LIVE_line_no_mapping_numbered': 'Diagramă linie goală (%{number})',
	'LIVE_line_named': 'Diagramă linie %{name}',
	'LIVE_line_named_numbered': 'Diagramă linie %{name} (%{number})',
	'LIVE_area_has_mapping': 'Diagramă suprafaţă %{categories} după %{values}',
	'LIVE_area_has_mapping_numbered': 'Diagramă suprafaţă %{categories} după %{values} (%{number})',
	'LIVE_area_no_mapping': 'Diagramă suprafaţă goală',
	'LIVE_area_no_mapping_numbered': 'Diagramă suprafaţă goală (%{number})',
	'LIVE_area_named': 'Diagramă suprafaţă %{name}',
	'LIVE_area_named_numbered': 'Diagramă suprafaţă %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Diagramă suprafaţă procentuală stivuită %{categories} după %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Diagramă suprafaţă procentuală stivuită %{categories} după %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Diagramă suprafaţă procentuală stivuită goală',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Diagramă suprafaţă procentuală stivuită goală (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Diagramă suprafaţă procentuală stivuită %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Diagramă suprafaţă procentuală stivuită %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Hartă termică %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Hartă termică %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Hartă termică goală',
	'LIVE_heatmap_no_mapping_numbered': 'Hartă termică goală (%{number})',
	'LIVE_heatmap_named': 'Hartă termică %{name}',
	'LIVE_heatmap_named_numbered': 'Hartă termică %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Reţea %{categories} după %{series} şi %{values}',
	'LIVE_network_opt_mapping_numbered': 'Reţea %{categories} după %{series} şi %{values} (%{number})',
	'LIVE_network_has_mapping': 'Reţea %{categories} după %{series}',
	'LIVE_network_has_mapping_numbered': 'Reţea %{categories} după %{series} (%{number})',
	'LIVE_network_no_mapping': 'Reţea goală',
	'LIVE_network_no_mapping_numbered': 'Reţea goală (%{number})',
	'LIVE_network_named': 'Reţea %{name}',
	'LIVE_network_named_numbered': 'Reţea %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Diagramă bară radială %{categories} după %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Diagramă bară radială %{categories} după %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Diagramă bară radială %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Diagramă bară radială %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Diagramă bară radială goală',
	'LIVE_radial_bar_no_mapping_numbered': 'Diagramă bară radială goală (%{number})',
	'LIVE_radial_bar_named': 'Diagramă bară radială %{name}',
	'LIVE_radial_bar_named_numbered': 'Diagramă bară radială %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Diagramă spirală %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Diagramă spirală %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Diagramă spirală goală',
	'LIVE_spiral_no_mapping_numbered': 'Diagramă spirală goală (%{number})',
	'LIVE_spiral_named': 'Diagramă spirală %{name}',
	'LIVE_spiral_named_numbered': 'Diagramă spirală %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Hartă arbore %{categories} după %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Hartă arbore %{categories} după %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Hartă arbore goală',
	'LIVE_treemap_no_mapping_numbered': 'Hartă arbore goală (%{number})',
	'LIVE_treemap_named': 'Hartă arbore %{name}',
	'LIVE_treemap_named_numbered': 'Hartă arbore %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Nor de cuvinte %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Nor de cuvinte %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Nor de cuvinte gol',
	'LIVE_wordcloud_no_mapping_numbered': 'Nor de cuvinte gol (%{number})',
	'LIVE_wordcloud_named': 'Nor de cuvinte %{name}',
	'LIVE_wordcloud_named_numbered': 'Nor de cuvinte %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Player de date %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Player de date %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Player de date gol',
	'LIVE_data_player_no_mapping_numbered': 'Player de date gol (%{number})',
	'LIVE_data_player_named': 'Player de date %{name}',
	'LIVE_data_player_named_numbered': 'Player de date %{name} (%{number})',
	'LIVE_map_has_mapping': 'Hartă %{locations}',
	'LIVE_map_has_mapping_numbered': 'Hartă %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Hartă goală',
	'LIVE_map_no_mapping_numbered': 'Hartă goală (%{number})',
	'LIVE_map_named': 'Hartă %{name}',
	'LIVE_map_named_numbered': 'Hartă %{name} (%{number})',
	'LIVE_point_has_mapping': 'Diagramă cu puncte %{categories} după %{values}',
	'LIVE_point_has_mapping_numbered': 'Diagramă cu puncte %{categories} după %{values} (%{number})',
	'LIVE_point_no_mapping': 'Diagramă cu puncte goală',
	'LIVE_point_no_mapping_numbered': 'Diagramă cu puncte goală (%{number})',
	'LIVE_point_named': 'Diagramă cu puncte %{name}',
	'LIVE_point_named_numbered': 'Diagramă cu puncte %{name} (%{number})',
	'LIVE_column_has_mapping': 'Diagramă coloană %{values}',
	'LIVE_column_has_mapping_numbered': 'Diagramă coloană %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Diagramă coloană %{categories} după %{values}',
	'LIVE_column_opt_mapping_numbered': 'Diagramă coloană %{categories} după %{values} (%{number})',
	'LIVE_column_no_mapping': 'Diagramă coloană goală',
	'LIVE_column_no_mapping_numbered': 'Diagramă coloană goală (%{number})',
	'LIVE_column_named': 'Diagramă coloană %{name}',
	'LIVE_column_named_numbered': 'Diagramă coloană %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Diagramă coloană stivuită %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Diagramă coloană stivuită %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Diagramă coloană stivuită %{categories} după %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Diagramă coloană stivuită %{categories} după %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Diagramă coloană stivuită goală',
	'LIVE_stacked_column_no_mapping_numbered': 'Diagramă coloană stivuită goală (%{number})',
	'LIVE_stacked_column_named': 'Diagramă coloană stivuită %{name}',
	'LIVE_stacked_column_named_numbered': 'Diagramă coloană stivuită %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Trasare prin puncte %{categories} după %{x} şi %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Trasare prin puncte %{categories} după %{x} şi %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Trasare prin puncte %{x} vs %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Trasare prin puncte %{x} vs %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Trasare prin puncte goală',
	'LIVE_scatter_no_mapping_numbered': 'Trasare prin puncte goală (%{number})',
	'LIVE_scatter_named': 'Trasare prin puncte %{name}',
	'LIVE_scatter_named_numbered': 'Trasare prin puncte %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Diagramă cascadă %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Diagramă cascadă %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Diagramă cascadă goală',
	'LIVE_waterfall_no_mapping_numbered': 'Diagramă cascadă goală (%{number})',
	'LIVE_waterfall_named': 'Diagramă cascadă %{name}',
	'LIVE_waterfall_named_numbered': 'Diagramă cascadă %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Construiţi o vizualizare proprie',
	'LIVE_empty_visualization_hint_description': 'Trageţi şi plasaţi coloanele aici sau în sloturile din stânga.',
	'LIVE_slots_required_field_description': '%{asterisk} indică un câmp necesar',
	'LIVE_slots_drag_and_drop_description': 'Trageţi şi plasaţi datele în sloturile de deasupra, pentru a construi şi filtra vizualizarea.',
	'requiredField': 'Câmp necesar',
	'fullScreenEnter': 'Introducere ecran complet',
	'fullScreenClose': 'Ieşire din ecran complet',
	'noExtraText_multipurpose': 'Placeholder cu scop general',
	'noExtraText_multipurpose_numbered': 'Placeholder multifuncţional (%{number})',
	'one_placeholder_vis': 'Placeholder vizualizare',
	'one_placeholder_vis_numbered': 'Placeholder de vizualizare (%{number})',
	'one_placeholder_text': 'Placeholder text',
	'one_placeholder_text_numbered': 'Placeholder de text (%{number})',
	'few_placeholder_text': 'Grup de %{count} placeholder-e de text',
	'many_placeholder_text': 'Grup de %{count} placeholder-e de text',
	'filter_includesAll': 'Include tot',
	'timeline_filter_moved_to': 'Filtrul de linie de timp %{id} a fost mutat la %{time}',
	'timelineSettingsButton': 'Opţiuni de redare',
	'autoPlay': 'Redare toate scenele',
	'loop': 'Buclă',
	'noSceneTransitionLabel': 'Fără',
	'sceneTransitionPropertyLabel': 'Tranziţie scenă',
	'animatedPathSceneTransitionLabel': 'Cale animată',
	'sweepSceneTransitionLabel': 'Glisare',
	'propAniAnimation': 'Animaţie',
	'propAniTypeEntrance': 'Animaţie la intrare',
	'propAniDirectionIn': 'Direcţie la intrare',
	'propAniTypeExit': 'Animaţie la ieşire',
	'propAniDirectionOut': 'Direcţie la ieşire',
	'propAniDirection': 'Direcţie',
	'timelineAnimationProperties': 'Deschidere proprietăţi animaţie',
	'editStoryCoachMarkTitle': 'Editare poveste',
	'editStoryCoachMarkContents': 'Faceţi clic pe pictograma stilou pentru a edita această poveste.',
	'addDataStoryCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date în povestea dumneavoastră.',
	'expandSceneCoachmarkTitle': 'Deschidere cronologie',
	'expandSceneCoachmarkContents': 'Animaţi o scenă prin ajustarea vizibilităţii obiectelor bazate pe timp şi durată.',
	'overviewCoachmarkTitle': 'Privire generală asupra scenelor',
	'overviewCoachmarkContents': 'Utilizaţi privirea generală asupra scenelor la începutul şi sfârşitul scenariului dumneavoastră pentru a afişa imaginea mare a tuturor scenelor. Dintr-o privire generală asupra scenelor, faceţi clic şi trageţi o scenă pentru interschimbarea ei altă scenă. Puteţi afişa sau ascunde privirea generală asupra scenelor în proprietăţile scenariului.',
	'animatedPathCoachmarkTitle': 'Cale animată',
	'animatedPathCoachmarkContents': 'Pentru a anima un obiect dintr-o scenă în alta, duplicaţi o scenă cu un obiect. Apoi mutaţi, redimensionaţi sau rotiţi obiectul duplicat în noua scenă.',
	'tabName_animation': 'Animaţie',
	'textWidgetIconPlaceholderText': 'Faceţi clic pentru a adăuga text',
	'buildVisHeader': 'Creaţi o vizualizare',
	'visIconPlaceholderText': 'Trageţi şi plasaţi câmpuri pentru a construi o vizualizare',
	'launchNewExplore': 'Explorare nouă',
	'addTo': 'Adăugare la',
	'addToExisting': 'Adăugare la existentă...',
	'exploreData': 'Explorare',
	'explore_remove_widget_styles': 'Proprietăţile vizualizării personalizate, cum ar fi setările de culoare nu vor persista în explorare.',
	'editNotebook': 'Editare widget',
	'thumbnails_error_fetching': 'Eroare la aducerea miniaturilor',
	'copy': '%{count} active copiate',
	'specConvertErr': 'A apărut o eroare la lipirea sau convertirea specificaţiei de tablou de bord',
	'specCopyErr': 'Eroare la copierea specificaţiei de tablou de bord',
	'pasteNotSupportedErr': 'Lipirea din %{name} nu este suportată.',
	'reportParam': 'raport',
	'filterWidgetCopyWarn': 'Vizualizarea Filtru nu a fost copiată, deoarece deocamdată nu există suport pentru filtre.',
	'upgradingDashboard': 'Realizare upgrade "%{name}" pentru %{version}...',
	'upgradeComplete': 'Upgrade finalizat',
	'individualTabProperties': 'Proprietăţi de filă individuale',
	'propMasterTabStylesLabel': 'Stil de filă master',
	'propTabPosition': 'Poziţie filă',
	'propTabTitle': 'Titlu',
	'propTabBackgroundColor': 'Culoare de umplere',
	'propTabTextColor': 'Culoare titlu',
	'propTabSelectedBarColor': 'Culoare bară selectată',
	'propTabRestoreDefaults': 'Restaurare valori implicite',
	'propIndividualTabStylesLabel': 'Stil de filă individual',
	'propIndividualTabStylesAriaLabel': 'Deschidere proprietăţi stil de filă individual',
	'propTabIconPosition': 'Poziţie pictogramă',
	'propLeftTitle': 'La stânga titlului',
	'propRightTitle': 'La dreapta titlului',
	'propTopTitle': 'Deasupra titlului',
	'propBottomTitle': 'Sub titlu',
	'propTabIconLabel': 'Vizual',
	'propTabIcon': 'Pictogramă',
	'propTabIconColor': 'Culoare pictogramă',
	'no_icon': 'Gol',
	'announcement': 'Anunţ',
	'api': 'API',
	'archive': 'Arhivare',
	'asset': 'Activ',
	'attachment': 'Ataşament',
	'audio': 'Audio',
	'bee': 'Albină',
	'blog': 'Blog',
	'bookmark': 'Semn de carte',
	'calendar': 'Calendar',
	'camera': 'Cameră',
	'capability': 'Aptitudine',
	'catalog': 'Catalog',
	'chat_message': 'Mesaj de chat',
	'checkout_cart': 'Înregistrare la ieşire coş',
	'client': 'Client',
	'clock': 'Ceas',
	'cloud': 'Cloud',
	'code': 'Cod',
	'data_quality': 'Calitate de date',
	'folder': 'Foldere',
	'forum': 'Forum',
	'glasses': 'Ochelari',
	'group': 'Grup',
	'hat': 'Pălărie',
	'headphone': 'Căşti',
	'hills': 'Coline',
	'home': 'Acasă',
	'idea': 'Idee',
	'image': 'Imagine',
	'inventory': 'Inventar',
	'like': 'Apreciere',
	'link': 'Legătură',
	'location': 'Locaţie',
	'manage': 'Gestionare',
	'pen': 'Stilou',
	'mobile_phone': 'Telefon mobil',
	'music': 'Muzică',
	'notifications': 'Notificări',
	'paint': 'Paint',
	'payment': 'Plată',
	'password_key': 'Cheie parolă',
	'people': 'Persoane',
	'person': 'Persoană',
	'phone': 'Telefon',
	'pin': 'Ţintuire',
	'print': 'Tipărire',
	'recording': 'Înregistrare',
	'repository': 'Repozitoriu',
	'role': 'Rol',
	'search': 'Căutare',
	'properties': 'Proprietăţi',
	'speaker': 'Difuzor',
	'star': 'Stea',
	'tag': 'Tag',
	'thumbs_up': 'Degete mari în sus',
	'thumbs_down': 'Degete mari în jos',
	'tools': 'Unelte',
	'traffic': 'Trafic',
	'trash': 'Gunoi',
	'twitter': 'Twitter',
	'unknown': 'Necunoscut',
	'user': 'Utilizator',
	'venn_diagram': 'Diagramă Venn',
	'video': 'Videoclip',
	'view': 'Vizualizare',
	'warning': 'Avertisment',
	'watch': 'Supraveghere',
	'watson': 'Watson',
	'wikis': 'Wiki-uri',
	'workspace': 'Spaţiu de lucru',
	'world': 'Mondial',
	'OnLoadFilterModifierDatasourceMismatch': 'Filtrele nu vor fi aplicate ţintei, deoarece tablourile de bord utilizează surse diferite.',
	'OnLoadFilterModifierColumnMismatch': 'Unul sau mai multe filtre nu au fost aplicate, deoarece coloanele care se potrivesc nu au putut fi găsite.',
	'eventGroupButtonLabel': 'Vizualizare conexiuni widget',
	'dockToolbar': 'Docare bară de unelte',
	'undockToolbar': 'Dezandocare bară de unelte',
	'propShowTitle': 'Afişare titlu'
});
